import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private userPermissions = new BehaviorSubject<string[]>([]);

    constructor() { }

    // Set user permissions
    setPermissions(permissions: string[]): void {
        this.userPermissions.next(permissions);
    }

    // Get user permissions as an observable
    getPermissions(): Observable<string[]> {
        return this.userPermissions.asObservable();
    }

    // Get current permissions value
    getCurrentPermissions(): string[] {
        return this.userPermissions.getValue();
    }

    // Check if user has specific permission
    hasPermission(permission: string): boolean {
        return this.userPermissions.getValue().includes(permission);
    }

    // Clear permissions
    clearPermissions(): void {
        this.userPermissions.next([]);
    }
}